import { Text } from '@southfields-digital/mpxlive-components';

import { HockeyContestant } from 'src/types/matchControl/contestant';

import { AdjustButton, ColorSwatch, ShortNameInput } from '../../components';
import styles from '../../MatchControl.module.scss';

type ScoreRowProps = {
  home: HockeyContestant;
  away: HockeyContestant;
  handleChangeScore: (contestant: HockeyContestant, amount: number) => void;
  handleChangeColor: (
    contestant: HockeyContestant,
    color: 'primaryColor' | 'secondaryColor',
    value: string
  ) => void;
  handleChangeShortName: (contestant: HockeyContestant, name: string) => void;
};

const ScoreRow = ({
  home,
  away,
  handleChangeScore,
  handleChangeColor,
  handleChangeShortName,
}: ScoreRowProps) => (
  <div className="flex flex-col gap-6 w-full">
    <div className="flex gap-2 justify-around items-center">
      <div className="flex gap-2 flex-1 justify-start">
        <div className="flex">
          <ColorSwatch
            color={home.primaryColor}
            onChange={(color) => handleChangeColor(home, 'primaryColor', color)}
          />
          <ColorSwatch
            color={home.secondaryColor}
            onChange={(color) => handleChangeColor(home, 'secondaryColor', color)}
          />
        </div>

        <Text className="!text-4xl w-16 text-center" as="h1" color="light">
          {home.score.points}
        </Text>
      </div>

      <Text className="!text-4xl" as="h1" color="light">
        -
      </Text>

      <div className="flex gap-2 flex-1 justify-end">
        <Text className="!text-4xl w-16 text-center" as="h1" color="light">
          {away.score.points}
        </Text>

        <div className="flex">
          <ColorSwatch
            color={away.primaryColor}
            onChange={(color) => handleChangeColor(away, 'primaryColor', color)}
          />
          <ColorSwatch
            color={away.secondaryColor}
            onChange={(color) => handleChangeColor(away, 'secondaryColor', color)}
          />
        </div>
      </div>
    </div>

    <div className={styles.CurrentScoreWrapper}>
      <div className="flex flex-col gap-4">
        <div className="flex gap-2 items-center">
          <AdjustButton
            onClick={() => handleChangeScore(home, (home.score.points || 0) - 1)}
            icon="minus"
            title="Subtract score for home team"
            disabled={(home.score.points || 0) < 1}
          />
          <AdjustButton
            onClick={() => handleChangeScore(home, (home.score.points || 0) + 1)}
            icon="plus"
            title="Add score for home team"
          />
        </div>

        <ShortNameInput
          value={home.shortName}
          onChange={(name) => handleChangeShortName(home, name)}
        />
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex gap-2 items-center">
          <AdjustButton
            onClick={() => handleChangeScore(away, (away.score.points || 0) - 1)}
            icon="minus"
            title="Subtract score for away team"
            disabled={(away.score.points || 0) < 1}
          />
          <AdjustButton
            onClick={() => handleChangeScore(away, (away.score.points || 0) + 1)}
            icon="plus"
            title="Add score for away team"
          />
        </div>

        <ShortNameInput
          value={away.shortName}
          onChange={(name) => handleChangeShortName(away, name)}
        />
      </div>
    </div>
  </div>
);

export default ScoreRow;
